import { FC } from "react";
import { StockNewsItem } from "@/models/stock-news";
import { ortexNewsStockUrl } from "@/lib/ortex-news";
import styles from "./StockLatestNews.module.scss";

/**
 * "Latest on <TICKER>": the newest ortex.news headlines for the stock, server
 * rendered below the page (like StockKeyData), each a followed link to the
 * article, plus the ticker's ortex.news hub. Fresh, quotable text and links to
 * the news site on the pages crawlers visit most. Renders nothing without items.
 */
interface Props {
    stock: { exchangesymbol: string; ticker: string };
    items?: StockNewsItem[] | null;
}

const formatDate = (iso: string) => new Date(`${iso}T00:00:00Z`).toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric", timeZone: "UTC" });

const StockLatestNews: FC<Props> = ({ stock, items }) => {
    if (!items?.length) return null;
    return (
        <section className={styles.StockLatestNews} aria-labelledby="stock-latest-news">
            <h2 id="stock-latest-news">{`Latest on ${stock.ticker}`}</h2>
            <ul>
                {items.map((item) => (
                    <li key={item.url}>
                        {item.date && <time dateTime={item.date}>{formatDate(item.date)}</time>}
                        <a href={item.url}>{item.title}</a>
                    </li>
                ))}
            </ul>
            <a className={styles.more} href={ortexNewsStockUrl(stock.exchangesymbol, stock.ticker)}>{`All ${stock.ticker} news on ORTEX News`}</a>
        </section>
    );
};

export default StockLatestNews;
